import React, {PropTypes, Component} from 'react';
import ToggleButton from '../../../common/components/c_ToggleButton';

export default function LicenseStatus(props) {

  const handleChange = (event, value) => {
    if (props.onChange) {
      props.onChange(event, value);
    }
  };

  return (
    <ToggleButton
      className='main-toggle'
      data-id='Ever Licensed?'
      style={{
        width: '100%'
      }}
      menuItems={props.statuses}
      value={props.value}
      onChange={handleChange}
    />
  );
}

LicenseStatus.propTypes = {
  statuses  : PropTypes.array.isRequired,
  value     : PropTypes.number,
  onChange  : PropTypes.func
};



// WEBPACK FOOTER //
// ./shared/react/applicant/LicensesForm/LicenseStatus.js